<div fxLayout="column" [ngStyle]="{'align-items': alignment}">
  <forge-checkbox #checkbox [dense]="forCellEdit || compact" style="white-space: nowrap;" [name]="Name"
    [id]="ControlId" attr.telemetry="{{Label}}" [disabled]="isViewOnly" (keydown)="handleKeyDown($event)"
    focusOnLoad [propertyMetadata]="propertyMetadata" [forCellEdit]="forCellEdit" (change)="fireValueChanged()">
    <label [for]="ControlId"><truncate-text [mainText]="Label"></truncate-text></label>
  </forge-checkbox>
  @if (!dense) {
    <span class="forge-typography--label1" style="color: rgba(0,0,0,0.6); margin-left: 1em;"
    [hidden]="!hint">{{hint}}</span>
  }
</div>
